import { ErrorTransformInterceptor } from '@/features/api/errorTransformInterceptor'
import { ILicenceLookupData, IMasterAPI } from '@/features/api/master/types'
import { MissingNetworkConnectionInterceptor } from '@/features/api/missingNetworkConnectionInterceptor'
import axios, { AxiosError } from 'axios'

class MasterAPI implements IMasterAPI {
    private $masterAPI = axios.create({
        baseURL: process.env.EXPO_PUBLIC_MASTER_API_URL,
    })

    constructor() {
        new MissingNetworkConnectionInterceptor(this.$masterAPI)

        new ErrorTransformInterceptor(this.$masterAPI)
    }

    async licenceLookup(licenceId: string): Promise<ILicenceLookupData> {
        const { data } = await this.$masterAPI.get<{ data: ILicenceLookupData }>(
            '/licence-lookup',
            {
                params: { apiKey: process.env.EXPO_PUBLIC_MASTER_API_KEY, id: licenceId },
                extras: {
                    errorIdentifier: (error: AxiosError<{ data?: { error: { code: number } } }>) =>
                        error.response?.data.data?.error.code.toString(),
                },
            }
        )

        return data.data
    }
}

export default new MasterAPI()
